// Sentinel value for the sidebar/tags-sheet "Show All" option, distinct from
// selectedTagId === null which means "untagged captures only" (see
// useDashboardData.js / capture_routes.py list_captures).
export const ALL_CAPTURES_FILTER = "__all__";

// Sentinel for the "今日" (Today) virtual filter - not a real tag, computed
// server-side from each capture's created_at/updated_at instead of a static
// tags array membership, since "today" changes automatically every day
// without any user action (see list_captures() in capture_routes.py).
export const TODAY_FILTER = "__today__";
